import isType from './is-type.js';

/**
 * 是否是布尔类型
 *
 * @param {Object} value 测试的值
 * @return {Boolean}
 */
var isBoolean = function (value) {
    return isType(value, 'Boolean');
};

export { isBoolean as default };
//# sourceMappingURL=is-boolean.js.map
